import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { FailedAttemptsSection } from '../components/FailedAttemptsSection';
import { RMASystemSection } from '../components/RMASystemSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { WhoIsForSection } from '../components/WhoIsForSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { ClosingCTA } from '../components/ClosingCTA';
export function SalesPage() {
  return <main className="min-h-screen bg-primary text-text-primary font-body overflow-x-hidden" data-id="element-388">
      <HeroSection data-id="element-389" />
      <OpeningHook data-id="element-390" />
      <ProblemSection data-id="element-391" />
      <FailedAttemptsSection data-id="element-392" />
      <RMASystemSection data-id="element-393" />
      <WhatYouGetSection data-id="element-394" />
      <WhoIsForSection data-id="element-395" />
      <HowItWorksSection data-id="element-396" />
      <ProofSection data-id="element-397" />
      <TestimonialsSection data-id="element-398" />
      <FAQSection data-id="element-399" />
      <OfferSection data-id="element-400" />
      <ClosingCTA data-id="element-401" />
    </main>;
}